const DEFAULT_LOGO_PATH = `${process.env.PUBLIC_URL || ""}/hibbert-logo.svg`;

export async function loadHibbertLogoDataUrl(logoPath = DEFAULT_LOGO_PATH) {
  const response = await fetch(logoPath);
  if (!response.ok) {
    throw new Error("Could not load the Hibbert logo for the invoice PDF.");
  }
  const svgText = await response.text();
  const blob = new Blob([svgText], { type: "image/svg+xml;charset=utf-8" });
  const objectUrl = URL.createObjectURL(blob);

  try {
    return await new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = 624;
        canvas.height = 128;
        const context = canvas.getContext("2d");
        if (!context) {
          reject(new Error("Could not render the Hibbert logo."));
          return;
        }
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/png"));
      };
      image.onerror = () => reject(new Error("Could not render the Hibbert logo."));
      image.src = objectUrl;
    });
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}
